/**
 * 今日座位預約清單（預約面板／櫃台）：與後端 /api/bookings/today 一致。
 * 取消／拒絕僅在「臨時取消」時顯示：UPDATED_DATE >= 預約日前一日 22:00（is_cancelled_today / is_rejected_today）。
 */
export function shouldShowSeatBookingInTodayList(r) {
  const s = String(r?.STATUS ?? '').trim().toLowerCase();
  if (s !== 'cancelled' && s !== 'rejected') return true;
  return Number(r?.is_cancelled_today) === 1 || Number(r?.is_rejected_today) === 1;
}
